<template>
    <div class="item-card">
        <div class="cont-item">
            <b-row no-gutters>
                <div class="text-center w-100">
                    <div class="btn-section btn-earning">
                        <router-link to="/basic/vaults">
                            <button class="btn btn-primary btn-home" type="button" id="start-earning">
                                START EARNING
                            </button>
                        </router-link>
                        <!-- <button
                    class="btn btn-secondary btn-home"
                    type="button"
                    style="padding: 0 15px; margin: auto"
                    >
                    Trade Now
                </button> -->
                    </div>
                </div>
            </b-row>
        </div>
        <div class="cont-item">
            <b-row no-gutters>
                <div class="text-center w-100">
                    <div class="text-item">
                        <img
                            src="/images/icons/bank.svg"
                            class="mob-size"
                            alt=""
                        />
                        <span id="total-value-locked">
                            {{ formatTotalValueLocked(totalValueLocked.toFixed(2)) }}
                        </span>
                    </div>
                </div>
                <div class="text-center w-100">
                    <div class="text-sub-item">Total Value Locked</div>
                </div>
            </b-row>
        </div>
        <!-- <div class="cont-item">
            <b-row no-gutters>
                <div class="text-center w-100">
                    <div class="text-item">
                        <img
                            src="/images/icons/user.svg"
                            class="mob-size"
                            alt=""
                        />
                        {{ formatCountUser(totalUser) }}
                    </div>
                </div>
                <div class="text-center w-100">
                    <div class="text-sub-item">Total Users</div>
                </div>
            </b-row>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            totalValueLocked: 0,
            totalUser: 21732123
        };
    },
    mounted() {
        this.$store
            .dispatch("API", {
                url: `/api/get_value_users`
            })
            .then(result => {
                this.totalValueLocked = result.locked_value;
                this.totalUser = result.total_user;
            });
    },
    methods: {
        formatCountUser(total) {
            return total.toLocaleString();
        },
        formatTotalValueLocked(total) {
            let totalFloat = parseFloat(total).toLocaleString();
            return `$${totalFloat}`;
        }
    }
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

.item-card {
    display: flex;
    justify-content: left;
    /* gap: 50px; */
}
.cont-item {
    position: static;
    max-width: 18vw;
    height: calc(18vw / 2.5);
    background: transparent;

    &:last-child {
        white-space: nowrap;
        margin-left: 3.4722222222222223vw;
    }

    .text-item {
        font-family: Bungee;
        font-style: normal;
        font-weight: normal;
        font-size: 1.66667vw; //$small-heading;
        line-height: calc(1.66667vw + 10px);
        // line-height: 29px;
        // line-height: 3.5vh;
        text-align: center;
        letter-spacing: 0.04em;
        color: $primary-4;
        padding-top: 1.5vw;
    }
    .text-sub-item {
        font-family: Exo;
        font-style: normal;
        font-weight: normal;
        font-size: 0.83333vw; //$small-heading-sub;
        // line-height: 16px;
        // line-height: 3vh;
        // text-align: center;
        line-height: calc(0.83333vw + 10px);
        text-transform: uppercase;
        color: $primary-4;
    }
    .mob-size {
        vertical-align: top;
        width: 2.442vw;
        height: 2.442vw;
    }
    .btn-earning {
        padding-bottom: 10px;
    }
}
@media screen and (min-width: 0px) and (max-width: 768px) {
    .item-card {
        gap: 5px !important;
    }
    .cont-item {
        width: 100% !important;
        height: 36px !important;
        max-width: 100%;
        .text-item {
            font-family: Bungee;
            font-style: normal;
            font-weight: normal;
            font-size: 1.66667vw; //$small-heading;
            line-height: calc(1.66667vw + 10px);
            // line-height: 29px;
            // line-height: 3.5vh;
            text-align: center;
            letter-spacing: 0.04em;
            color: $primary-4;
            padding-top: 1.5vw;
        }
        .text-sub-item {
            font-family: Exo;
            font-style: normal;
            font-weight: normal;
            font-size: 0.83333vw; //$small-heading-sub;
            // line-height: 16px;
            // line-height: 3vh;
            // text-align: center;
            line-height: calc(0.83333vw + 10px);
            text-transform: uppercase;
            color: $primary-4;
        }
        .mob-size {
            vertical-align: top;
            width: 2.442vw;
            height: 2.442vw;
        }
        .btn-earning {
            padding-bottom: 10px;
        }
    }
}
@media screen and (min-width: 0px) and (max-width: 768px) {
    .item-card {
        gap: 5px !important;
    }
    .cont-item {
        width: 100% !important;
        height: 36px !important;
        max-width: 100%;
        .text-item {
            font-size: 16px !important; //$section-sub-title
            line-height: 19px !important;
        }
        .text-sub-item {
            font-size: 10px !important;
            line-height: 13px !important;
        }
        .mob-size {
            width: 15px;
            height: 15px;
        }
    }
}
</style>
